import { render, staticRenderFns } from "./CreateEditLegacyExamModal.vue?vue&type=template&id=3c09a024&scoped=true"
import script from "./CreateEditLegacyExamModal.vue?vue&type=script&lang=js"
export * from "./CreateEditLegacyExamModal.vue?vue&type=script&lang=js"
import style0 from "./CreateEditLegacyExamModal.vue?vue&type=style&index=0&id=3c09a024&prod&scoped=true&lang=css"
import style1 from "./CreateEditLegacyExamModal.vue?vue&type=style&index=1&id=3c09a024&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c09a024",
  null
  
)

export default component.exports